import { useRouter } from 'next/router';
import { BenefitsCard, BenefitsItem } from './BenefitsCard';
import { TextParagraph, TextLink, Link } from '@angeplus/prever-component-lib';

export const MultipleBenefitsCard = () => {
  const router = useRouter();

  return (
    <BenefitsCard
      title="Múltiplos benefícios"
      image={`${router.basePath}/assets/img/family-benefits.webp`}
      items={items}
      footer={
        <TextParagraph>
          Para saber mais sobre coberturas e limites, acessar o{' '}
          <Link href="https://www.planoprever.com.br/manual" target="_blank">
            <TextLink>Manual das Assistências</TextLink>
          </Link>
          .
        </TextParagraph>
      }
    />
  );
};

const items: BenefitsItem[] = [
  {
    description:
      'Assistência funeral: translado livre no estado de residência do titular (local do óbito até a cidade de residência).',
    status: 'active',
  },
  {
    description: 'Exclusivamente via terrestre.',
    status: 'active',
  },
  {
    description:
      'Teleconsultas mensais em diversas especialidades incluídas no plano.',
    status: 'active',
  },
  {
    description: 'Assistência jurídica (1 consulta por óbito).',
    status: 'active',
  },
  {
    description:
      'Acolhimento ao luto (3 sessões para qualquer beneficiário do plano).',
    status: 'active',
  },
  {
    description:
      'Assistência sepultamento: benefício opcional que você pode contratar por R$ 15,00 por dependente ou R$ 45,00 no benefício família.',
    status: 'pending',
  },
  {
    description:
      'Proteção pet: benefício opcional que você pode contratar por R$ 15,00 por pet.',
    status: 'pending',
  },
];
